import { Component, OnInit } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { DynamicDialogRef, DynamicDialogConfig } from "primeng/dynamicdialog";
import { GroupsService } from "../..";
import { UpdateStudentGroupRequest } from "../../services/UpdateStudentGroupRequest";

@Component({
	selector: "app-student-group-edit",
	templateUrl: "./student-group-edit.component.html",
	styleUrls: ["./student-group-edit.component.css"],
})
export class StudentGroupEditComponent implements OnInit {
	constructor(
		public ref: DynamicDialogRef,
		private dialogConfig: DynamicDialogConfig,
		private groupService: GroupsService,
		private confirmationService: ConfirmationService
	) {}

	ngOnInit(): void {
		this.SelectedStudentGroup = this.dialogConfig.data.SelectedStudentGroup;
		this.SchoolID = this.dialogConfig.data.SchoolID;

		this.GroupName = this.SelectedStudentGroup.GroupName;
	}

	///////////////////////////////////////////
	// Data
	///////////////////////////////////////////

	SelectedStudentGroup: any;
	SchoolID: any;

	//Form
	GroupName: any = "";

	///////////////////////////////////////////

	///////////////////////////////////////////
	// Buttons
	///////////////////////////////////////////
	onUpdateName() {
		//Update Group Name

		let parms: UpdateStudentGroupRequest = {
			ApplicationItemID: "",
			GroupID: this.SelectedStudentGroup.GroupID,
			GroupName: this.GroupName,
			SchoolID: this.SchoolID,
			Active: this.SelectedStudentGroup.Active == "Yes" ? 1 : 0,
		};

		var result = this.groupService.UpdateGroup(parms);
		result.subscribe(
			(response) => {
				if (response) {
					this.SelectedStudentGroup.GroupName = this.GroupName;

					//Success Dialog
					this.confirmationService.confirm({
						key: "Name",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "The Group's Name was Successfully Updated",
						header: "Update Group Name",
						icon: "fa",
						accept: () => {},
					});
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "Name",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not Update the Group's Name",
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {
				return;
			}
		);
	}

	///////////////////////////////////////////
}
